import { render, staticRenderFns } from "./GastroPancolonscopiaEditComponent.vue?vue&type=template&id=07c50145"
import script from "./GastroPancolonscopiaEditComponent.vue?vue&type=script&lang=js"
export * from "./GastroPancolonscopiaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports